export default __webpack_public_path__ + "51669c9f465d6269eeaf49331574daf4.svg";